module.exports = "../../../../platform/assets/pageMainIcon/industry_jichudanganlei8.svg";